var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-login"},[_c('BaseEmpty',_vm._b({attrs:{"btnText":"立即登录"},on:{"btnClick":_vm.handleLogin}},'BaseEmpty',_vm.$attrs,false)),_c('LoginDialog',{ref:"LoginDialogRef",on:{"close":_vm.hanleLoginDialogClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }